var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"error"},[_c('h1',{ref:"error.main"},[_vm._v("404: Not Found")]),_vm._v(" "),_c('a',{staticClass:"error__link",attrs:{"href":_vm.$router.resolve({ name: 'login' }).href}},[_vm._v("\n        Login page\n      ")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c797e49","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/404.vue
// module id = 121
// module chunks = 0